import { Component } from '@angular/core';

import { MenuBottom } from '../menu-bottom/menu-bottom';
import { Sale } from './sale/sale';
import { DashboardTasks } from './tasks/tasks';
import { TranslatePipe } from '@ngx-translate/core';
@Component({
  selector: 'app-dashboard',
  imports: [Sale, MenuBottom, DashboardTasks, TranslatePipe],
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.css',
})
export class Dashboard {
  view: 'dashboard' | 'tasks' = 'dashboard';
  isSidebarOpen = false;

  showDahboard() {
    this.view = 'dashboard';
  }
  showTasks() {
    this.view = 'tasks';
  }
}
